export default "__VITE_ASSET__B$jjGa3r__"